import { createSelector } from 'reselect';

const selectJournals = (state: any) => state.journals;

export const selectJournalsCurrentItem = createSelector([selectJournals], (journals) => journals.current);

export const selectJournalsListItems = createSelector([selectJournals], (journals) => journals.list);

export const selectJournalsItemById = (itemId: any) =>
    createSelector(selectJournalsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectJournalsQueryItems = createSelector([selectJournals], (journals) => journals.query);

export const selectJournalsCreatedItem = createSelector([selectJournals], (journals) => journals.create);

export const selectJournalsUpdatedItem = createSelector([selectJournals], (journals) => journals.update);

export const selectJournalsReadItem = createSelector([selectJournals], (journals) => journals.read);

export const selectJournalsDeletedItem = createSelector([selectJournals], (journals) => journals.delete);

export const selectJournalsSearchedItems = createSelector([selectJournals], (journals) => journals.search);

export const selectJournalsItemsCount = createSelector([selectJournals], (journals) => journals.count);

export const selectJournalsItemsFilter = createSelector([selectJournals], (journals) => journals.filter);